import { createSlice } from "@reduxjs/toolkit";

const BlocklistSlice = createSlice({
  name: "blocklist",
  initialState: {
    blocklists: [],
    totalCount: 0,
    loading: false,
    error: null,
    successMessage: null,  
    errorMessage: null, 
  },
  reducers: {
    fetchBlockListRequest: (state, action) => {
      state.loading = true;
    },
    fetchBlockListSuccess: (state, action) => {
      state.loading = false;
     state.blocklists = JSON.parse(JSON.stringify(action.payload.data));
      state.totalCount = action.payload.total;
    },
    fetchBlockListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    blockNumberRequest: (state) => {
      state.loading = true;
      state.successMessage=null;
      state.errorMessage = null;
    },
    blockNumberSuccess: (state, action) => {
  state.loading = false;
  state.successMessage = action.payload?.message || "Blocked successfully";
},

blockNumberFailure: (state, action) => {
  state.loading = false;
  state.errorMessage = action.payload;
},
    deleteBlockNumberRequest: (state, action) => {
    state.loading = true;
  },
  deleteBlockNumberSuccess: (state, action) => {
    state.loading = false;
    state.blocklists = state.blocklists.filter(
      (item) => item.phone !== action.payload
    );
  },
  deleteBlockNumberFailure: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },
  clearBlockMessages: (state) => {
  state.successMessage = null;
  state.errorMessage = null;
}
  },
});

export const {
  blockNumberRequest,
  blockNumberSuccess,
  blockNumberFailure,
  fetchBlockListRequest,
  fetchBlockListSuccess,
  fetchBlockListFailure,
  deleteBlockNumberRequest,
  deleteBlockNumberSuccess,
  deleteBlockNumberFailure,
  clearBlockMessages
} = BlocklistSlice.actions;

export default BlocklistSlice.reducer;
